/* eslint-disable consistent-return */
import './styluses/main.styl'
import './styluses/fonts.css'

import '@formatjs/intl-datetimeformat/polyfill-force'
import '@formatjs/intl-datetimeformat/locale-data/ru'
import '@formatjs/intl-datetimeformat/locale-data/kk'
import '@formatjs/intl-datetimeformat/add-all-tz'

import Vue from 'vue'
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getRemoteConfig, fetchAndActivate } from 'firebase/remote-config'
import { getAuth } from 'firebase/auth'
import numeral from 'numeral'
import 'numeral/locales'
import vueMoment from 'vue-moment'
import moment from 'moment-timezone'
import 'moment/locale/ru'
import 'moment/locale/kk'
import { VueMaskDirective } from 'v-mask'
import JsonViewer from 'vue-json-viewer'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store'
import i18n from './i18n'
import rules from './utils/rules'
import { initDeepLinkHandling, isDeepLink, getDeepLinkRoute } from './utils/deeplink'
import { initSentry } from './utils/sentry'
import initSessionWatcher from './utils/sessionWatcher'

Vue.config.productionTip = false

initSentry({ Vue, router })

function initWebFirebase() {
  const firebaseConfig = JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG)
  const firebaseApp = initializeApp(firebaseConfig)
  store.dispatch('tools/setFirebaseApp', firebaseApp)
}

function initWebFirebaseAuth() {
  const auth = getAuth(store.state.tools.firebaseApp)
  auth.useDeviceLanguage()
  store.dispatch('auth/setFirebaseAuth', auth)
}

let helpCrunchWebRecovering = false

function subscribeWebHelpCrunchEvents() {
  window.HelpCrunch('onReady', () => {
    helpCrunchWebRecovering = false
  })

  window.HelpCrunch('onNewUnreadChat', (data) => {
    store.dispatch('tools/setHelpCrunchUnreadCount', data.unreadChats)
  })

  window.HelpCrunch('onChatClose', () => {
    window.HelpCrunch('hideChatWidget')
  })
}

function initWebHelpCrunch() {
  /* eslint-disable */
  window.helpcrunchSettings = {
    organization: 'apprekassa',
    appId: '57bcceb5-963f-4970-a1ef-b20ce90d53f3',
  };
  (function(w,d){var hS=w.helpcrunchSettings;if(!hS||!hS.organization)
  {return;}var widgetSrc='https://'+hS.organization+'.widget.helpcrunch.com/';
  w.HelpCrunch=function(){w.HelpCrunch.q.push(arguments)};w.HelpCrunch.q=[];
  function r(){if (d.querySelector('script[src="' + widgetSrc + '"')) { return; }
  var s=d.createElement('script');s.async=1;s.type='text/javascript';s.src=widgetSrc;(d.body||d.head).appendChild(s);
  }if(d.readyState === 'complete'||hS.loadImmediately){r();}
  else if(w.attachEvent){w.attachEvent('onload',r)}else
  {w.addEventListener('load',r,false)}})(window, document)
  /* eslint-enable */

  subscribeWebHelpCrunchEvents()
}

// Если у сохранённого в куках устройства HelpCrunch больше нет клиента (например, его удалили
// в панели HelpCrunch), init-запрос /new-api/customer/auth отвечает 400 и SDK молча перестаёт
// реагировать на команды (onReady не приходит). Лечится только сбросом хранилища виджета
// и повторной загрузкой его скрипта.
function recoverWebHelpCrunch() {
  if (helpCrunchWebRecovering) return
  helpCrunchWebRecovering = true

  // Куки виджета могут быть выставлены как на хост, так и на родительский домен
  // (например, .rekassa.kz с прода) — удаляем по всем уровням
  const expires = 'expires=Thu, 01 Jan 1970 00:00:00 GMT'
  const hostParts = window.location.hostname.split('.')
  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0].trim()
    if (name.includes('helpcrunch')) {
      document.cookie = `${name}=; ${expires}; path=/`
      for (let i = 0; i < hostParts.length - 1; i += 1) {
        document.cookie = `${name}=; ${expires}; path=/; domain=${hostParts.slice(i).join('.')}`
        document.cookie = `${name}=; ${expires}; path=/; domain=.${hostParts.slice(i).join('.')}`
      }
    }
  })
  Object.keys(localStorage)
    .filter((key) => key.includes('helpcrunch') || key === 'hc-visitor-hash')
    .forEach((key) => localStorage.removeItem(key))

  document.querySelectorAll('.helpcrunch-iframe-wrapper, script[src*="helpcrunch"]').forEach((el) => el.remove())

  window.HelpCrunch = (...args) => { window.HelpCrunch.q.push(args) }
  window.HelpCrunch.q = []
  const script = document.createElement('script')
  script.async = 1
  script.type = 'text/javascript'
  script.src = `https://${window.helpcrunchSettings.organization}.widget.helpcrunch.com/`
  document.body.appendChild(script)

  subscribeWebHelpCrunchEvents()

  if (store.state.auth.user && store.state.auth.user.phone) {
    window.HelpCrunch('userAuth', { email: store.state.auth.user.phone, user_id: store.state.auth.user.phone })
  }
}

function initFacebookPixel() {
  /* eslint-disable */
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '852069506206285');
  /* eslint-enable */
}

function initCordovaHelpCrunch() {
  window.cordova.plugins.HelpCrunchPlugin.initialize({
    organization: import.meta.env.VITE_HELPCRUNCH_ORGANIZATION,
    applicationId: import.meta.env.VITE_HELPCRUNCH_APP_ID,
    applicationSecret: import.meta.env.VITE_HELPCRUNCH_APP_SECRET,
  })

  window.addEventListener('onNewUnreadChat', (event) => {
    store.dispatch('tools/setHelpCrunchUnreadCount', event.count)
  }, false)
}

function initFirebaseAnalytics() {
  if (window.cordova) {
    window.FirebasePlugin.setAnalyticsCollectionEnabled(true)
    // Для Cordova, session_start отправляется автоматически SDK
    // при первом запуске FirebasePlugin
  } else {
    const analytics = getAnalytics(store.state.tools.firebaseApp)
    store.dispatch('analytics/setFirebaseAnalytics', analytics)
  }
}

function initRemoteConfig() {
  // Промис первой активации: на свежей установке до fetchAndActivate все ключи
  // пустые, и firebaseRemoteConfigGetString ждёт его перед чтением.
  // resolve и при ошибке - читаем как раньше (пусто/кэш SDK)
  const ready = new Promise((resolve) => {
    if (window.cordova) {
      const fetchTimeout = 60
      const minimumFetchInterval = 3600
      window.FirebasePlugin.setConfigSettings(fetchTimeout, minimumFetchInterval, () => {}, () => {})
      window.FirebasePlugin.fetchAndActivate(() => resolve(), () => resolve())
    } else {
      const remoteConfig = getRemoteConfig(store.state.tools.firebaseApp)
      remoteConfig.settings.minimumFetchIntervalMillis = 3600000
      store.dispatch('tools/setFirebaseRemoteConfig', remoteConfig)
      fetchAndActivate(remoteConfig).then(() => resolve()).catch(() => resolve())
    }
  })
  store.dispatch('tools/setFirebaseRemoteConfigReady', ready)
}

function configVue() {
  Vue.use(vueMoment, { moment })
  Vue.use(JsonViewer)
  Vue.use(VueDOMPurifyHTML)

  numeral.locale('en')
  numeral.localeData().delimiters.thousands = ' '
  numeral.fn._format = numeral.fn.format
  numeral.fn.format = function format(a, b) { return numeral.fn._format.call(this, a, b || numeral._.defaultRoundingFunction) }
  numeral._.defaultRoundingFunction = Math.floor
  Vue.filter('numeral', (value, format = '0,0') => numeral(value).format(format))
  Vue.filter('beautiful-minus', (value) => value.replace('-', '− '))
  Vue.filter('phone', (value) => (value && value.length === 12 ? value.replace(/[^0-9]/g, '').replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 ($2) $3-$4-$5') : value))

  Vue.directive('mask', VueMaskDirective)

  Vue.prototype.rules = rules

  Vue.prototype.$goBack = () => {
    window.history.length > 1 ? router.go(-1) : router.push('/kkm')
  }

  Vue.prototype.$openLink = (link, target) => {
    if (isDeepLink(link)) {
      return router.push(getDeepLinkRoute(link))
    }
    if (window.cordova !== undefined) {
      return window.cordova.InAppBrowser.open(link, target, 'hidenavigationbuttons=yes,hideurlbar=yes,zoom=no,toolbarcolor=#272727,closebuttoncolor=#ffffff')
    }
    return window.open(link, target)
  }

  Vue.prototype.$showHelpCrunch = () => {
    if (window.cordova !== undefined) {
      window.cordova.plugins.HelpCrunchPlugin.showChatScreen(() => {}, () => {})
    } else {
      // Мёртвый виджет: скрипт выполнился (стаба с очередью уже нет), iframe создан, но внутри пусто —
      // init упал. Событие onReady признаком не является: при реальном отказе auth оно всё равно приходит.
      const scriptLoaded = typeof window.HelpCrunch === 'function' && !window.HelpCrunch.q
      const frame = document.querySelector('iframe[name="helpcrunch-iframe"]')
      if (scriptLoaded && frame && frame.contentDocument && !frame.contentDocument.querySelector('#helpcrunch-container')) {
        recoverWebHelpCrunch()
      }
      window.HelpCrunch('showChatWidget')
      window.HelpCrunch('openChat')
    }
  }

  Vue.prototype.$isCordova = () => window.cordova !== undefined

  Vue.prototype.$isAndroid = () => window.cordova !== undefined && window.device.platform === 'Android'

  Vue.prototype.$isTestMode = () => import.meta.env.VITE_TEST === 'true'
}

function initWebApp() {
  initWebFirebase()
  initWebFirebaseAuth()
  initSessionWatcher()
  initFacebookPixel()

  // Инициализируем Firebase Analytics ДО создания Vue instance
  // чтобы session_start был первым событием
  initFirebaseAnalytics()
  initRemoteConfig()

  // Отправляем первое событие для триггера автоматического session_start
  // Это гарантирует правильную атрибуцию источников трафика
  store.dispatch('analytics/logEvent', {
    eventName: 'app_init',
    eventProperties: {},
  })

  initWebHelpCrunch()

  const vue = new Vue({
    router,
    vuetify,
    store,
    i18n,
    render: (h) => h(App),

  })
  configVue()

  vue.$mount('#app')
}

function initCordovaApp() {
  // Инициализируем Firebase Analytics ДО создания Vue instance
  // чтобы session_start был первым событием
  initFirebaseAnalytics()
  initRemoteConfig()

  // Отправляем первое событие для триггера автоматического session_start
  store.dispatch('analytics/logEvent', {
    eventName: 'app_init',
    eventProperties: {},
  })

  initCordovaHelpCrunch()

  const vue = new Vue({
    router,
    vuetify,
    store,
    i18n,
    render: (h) => h(App),
  })
  configVue()

  vue.$mount('#app')

  // Handling Android "Back button"
  document.addEventListener('backbutton', () => {
    if (router.history.current.path === '/' || router.history.current.path === '/kkm') {
      window.plugins.appMinimize.minimize()
    } else {
      router.go(-1)
    }
  }, false)

  // Handling deeplinks
  initDeepLinkHandling(router)

  // Hide scrollbar in iOS
  if (window.cordova !== undefined && window.device.platform === 'iOS') {
    window.plugins.hideScrollbar.hide(() => {})
  }
}

if (window.cordova) {
  document.addEventListener('deviceready', () => {
    initCordovaApp()
  })
} else {
  initWebApp()
}
